import { useTranslation } from 'react-i18next';

import { Input, Select } from '@saas-kit/ui';

import { inferValueType, type SettingDraft } from './draft';

interface Props {
  valueKey: string;
  draft: SettingDraft;
  onChange: (next: SettingDraft) => void;
  disabled?: boolean;
}

export function SettingValueEditor({
  valueKey,
  draft,
  onChange,
  disabled,
}: Props): JSX.Element {
  const { t } = useTranslation('adminSettings');
  const valueType = inferValueType(valueKey, draft.value);

  if (valueType === 'bool') {
    return (
      <Select
        value={String(draft.value)}
        onChange={(e) =>
          onChange({ ...draft, value: e.target.value === 'true', text: '' })
        }
        disabled={disabled}
        aria-label={valueKey}
      >
        <option value="true">{t('value.select_true')}</option>
        <option value="false">{t('value.select_false')}</option>
      </Select>
    );
  }

  return (
    <Input
      type="text"
      inputMode="numeric"
      value={draft.text}
      onChange={(e) => onChange({ ...draft, text: e.target.value })}
      placeholder={
        valueType === 'nullable_int'
          ? t('value.placeholder_nullable_int')
          : t('value.placeholder_int')
      }
      disabled={disabled}
      aria-label={valueKey}
      spellCheck={false}
    />
  );
}
